import React from "react"
import {AllowedBillPayTermsColumns} from "./BillPayTerms.types"
import {BillpayTerms} from "../../resources/billpayTerms"
import {Resource} from "../../resources/common"
import {Meta} from "../../resources/common"
import {
	DataTable,
	DataTableHead,
	DataTableBody,
	DataTableCell,
	DataTableRow,
} from "../../components/DataTable/DataTable"
import PagingNavBar from "../../components/PagingNavBar/PagingNavBar"
import BillPayTermsRow from "./BillPayTermsRow"

interface BillPayTermsTableProps {
	billpayTerms: BillpayTerms[]
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	include?: Resource[]
	includedColumns: AllowedBillPayTermsColumns[]
	meta?: Meta
	fullHeight?: boolean
}

export default function BillPayTermsTable({
	billpayTerms,
	fullHeight,
	includedColumns,
	hasNext,
	hasPrev,
	hasResults,
	isUsingPaging,
	meta,
	prev,
	next,
	include,
}: BillPayTermsTableProps) {
	const noContent = billpayTerms.length === 0
	return (
		<div className="billpay-terms-table">
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				stickyAction={fullHeight}
				noContentText="No bill pay terms found"
			>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{billpayTerms.map((p) => (
						<BillPayTermsRow key={p.id} include={include} includedColumns={includedColumns} billpayTerms={p} />
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
